/* ===========================================================================
   VJ-CORR-D192 — LE PIED DE PAGE RESTE OUVERT SUR ORDINATEUR
   6 septembre 2026
   ---------------------------------------------------------------------------
   `<details>` fermé masque son contenu en HTML, pas en CSS : au-dessus de
   750 px, un `display: block` sur la liste ne suffit pas — le navigateur ne
   rend tout simplement pas les enfants d'un `details` sans `open`.

   Ces quelques lignes posent `open` au-dessus de 750 px et le retirent en
   dessous. C'est le seul JavaScript de ce bloc ; sans lui, le pied de page
   reste replié sur ordinateur, ce qui n'est pas grave mais n'est pas voulu.

   L'attribut `name` rend les groupes exclusifs sur téléphone. On le retire
   sur ordinateur, sinon ouvrir l'un refermerait l'autre alors qu'on veut les
   deux ouverts.

   Rollback : supprimer la ligne de layout/theme.liquid et ce fichier.
   =========================================================================== */
(function () {
  'use strict';
  var LARGE = window.matchMedia('(min-width: 750px)');

  function accorder() {
    var plis = document.querySelectorAll('[data-vj-pli]');
    for (var i = 0; i < plis.length; i++) {
      if (LARGE.matches) {
        plis[i].removeAttribute('name');
        plis[i].open = true;
      } else {
        plis[i].setAttribute('name', 'vj-footer');
        plis[i].open = false;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', accorder);
  } else {
    accorder();
  }
  if (LARGE.addEventListener) LARGE.addEventListener('change', accorder);
  else if (LARGE.addListener) LARGE.addListener(accorder);
  document.addEventListener('shopify:section:load', accorder);
})();
